/* VENDORED — DO NOT EDIT BY HAND. See scripts/vendor-manifest.mjs.
   source:  andavo-dev libs/client/shared/shared/util/common/src/lib/cn.ts
   commit:  b875130356
   repoint: this file maps to @andavo/* at merge into andavo-dev.
 */
import { type ClassValue, clsx } from 'clsx';
import {
  createTailwindMerge,
  getDefaultConfig,
  mergeConfigs,
} from 'tailwind-merge';

// Extend tailwind-merge with custom config for our custom class groups
const twMerge = createTailwindMerge(() =>
  mergeConfigs(getDefaultConfig(), {
    extend: {
      classGroups: {
        size: ['size-icon-sm', 'size-icon-md', 'size-icon-lg', 'size-icon-xl'],
        'font-size': ['text-xxs'],
      },
    },
  }),
);
export const cn = function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
};
